
import './App.css';
import { useEffect } from 'react';
import HomePage from './Component/HomePage';
import LoginPage from './Component/LoginPage';
import SignupPage from './Component/SingupPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WaitlistPage from './Component/WaitListPage';
import { Toaster, toast } from "sonner";

import CreateProfile from './Component/CreateProfile';
import Dashboard from './Component/Dashboard';
import CreatorPage from './Component/CreatorPage';
import OnboardingStepOne from './Component/OnboardingStepOne';
import PublicRoute from './Component/Protected/PublicRoute';
import ProtectedRoute from './Component/Protected/ProtectedRoute';
import ForgotPassword from './Component/Forgotpassword';
import ResetPassword from './Component/ResetPassword';
import FindCreators from './Component/FindCreators';
import { getCurrentUser,getCurrentBusiness } from './Redux/Asycthunk';
import { useDispatch } from 'react-redux';
import VerifyEmailInfo from './Component/verifyEmailInfo';
import VerifyEmailToken from './Component/verifyEmailToken';
import PaymentSuccess from './Component/PaymentSuccessful';
import DemoPage from './Component/DemoPage';
import CustomerPage from './Component/CustomerPage';
import Profile from './Component/Profile';
import QrPage from './Component/QrPage';
import PrivacyPolicy from './Component/PrivacyPolicy';
import Terms from './Component/Terms';
import CookiePolicy from './Component/CookiePolicy';
import WristbandProduct from './Component/WristbandProduct';
import PaymentCancelled from './Component/PaymentCancelled';
import Analytics from './Component/Analytics';
import Referrals from './Component/Referrals';




const token = localStorage.getItem("token");

const api = process.env.REACT_APP_API_URL;
const getSource = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("utm_source") || "direct";
};

// in App.jsx
<Toaster />

const updateActivity = () => {
  localStorage.setItem("lastActivity", Date.now());
};

// inside your submit
toast.success("You're on the waitlist 🚀");
toast.error("Something went wrong");

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
  const checkUser = async () => {
    if (!token) return;

    try {
await dispatch(getCurrentUser()).unwrap();
await dispatch(getCurrentBusiness()).unwrap();
    } catch (err) {
    
      if (err === "User not found") {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
  };

  checkUser();
}, [dispatch,]);

useEffect(() => {
  const events = ["mousemove", "keydown", "click", "scroll"];

  events.forEach((event) =>
    window.addEventListener(event, updateActivity)
  );

  return () => {
    events.forEach((event) =>
      window.removeEventListener(event, updateActivity)
    );
  };
}, []);

useEffect(() => {
  const interval = setInterval(() => {
    const lastActivity = localStorage.getItem("lastActivity");

    if (!lastActivity) return;

    const now = Date.now();
    const diff = now - Number(lastActivity);

    const HOURS_24 = 24 * 60 * 60 * 1000;

    if (diff > HOURS_24) {
    

      localStorage.clear();
      window.location.href = "/login";
    }
  
  }, 60000); // check every 1 minute

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  const source = getSource();

  const lastVisit = localStorage.getItem("lastVisit");
  const now = Date.now();

  if (!lastVisit || now - lastVisit > 30 * 60 * 1000) {
     fetch(`${api}/track-visit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ source }),
    });

    localStorage.setItem("lastVisit", now);
  }
  
}, []);

  return (
    <div className="App">
      <Router>
        <Toaster position="top-center" />
    

        <Routes>

          {/* PUBLIC ROUTES */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <HomePage />
               
              </PublicRoute>
            }
          />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />



  


          <Route
            path="/signup"
            element={
              <PublicRoute>
                <SignupPage />
              </PublicRoute>
            }
          />

            <Route
            path="/payments"
            element={
      
                <PaymentSuccess />
            
            }
          />

          <Route path="/waitlist" element={<WaitlistPage />} />
<Route path="/demo/:slug" element={<DemoPage />} />
<Route path="/b/:slug" element={<CustomerPage />} />



          <Route path="/verify-email-info/" element={<VerifyEmailInfo />} />
             <Route path="/privacy/" element={<PrivacyPolicy />} />
              <Route path="/terms/" element={<Terms />} />
               <Route path="/cookies" element={<CookiePolicy />} />
               <Route path='/product' element={<WristbandProduct/> } />
                <Route path='/payment-success' element={<PaymentSuccess/> } />
                 <Route path='/payment-cancelled' element={<PaymentCancelled/> } />
                 
               
               

                        

       <Route path="/verify-email/:token" element={<VerifyEmailToken />} />

          <Route path="/creator/:username" element={<CreatorPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
                 <Route path="/find-creators" element={<FindCreators />} />

          {/* PROTECTED ROUTES */}
        <Route
  path="/dashboard"
  element={
    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  }
>
  <Route path="profile" element={<Profile />} />
  <Route path="Qr/:slug" element={<QrPage />} />
    <Route path="Analytics" element={<Analytics />} />
      <Route path="Referrals" element={<Referrals />} />

</Route>

          <Route
            path="/onboarding-step-one"
            element={
              <ProtectedRoute>
                <OnboardingStepOne />
              </ProtectedRoute>
            }
          />

          <Route
            path="/onboarding-step-two"
            element={
              <ProtectedRoute>
                <CreateProfile />
              </ProtectedRoute>
            }
          />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
